import {defineStore} from 'pinia';
import {ITeacherError} from "@/consts/interfaces";

interface TeacherError {
  teacher_error: ITeacherError;
}

export const useErrorStore = defineStore('errorStore', {
  // state
  state: (): TeacherError => {
    return {
      teacher_error: null
    }
  },
  // getters
  getters: {
    getTeacherError: (state) => {
      return state.teacher_error
    },
  },
  // actions
  actions: {
    saveTeacherError(payload:ITeacherError) {
      this.teacher_error = payload
    },
  }
})